var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"popup reinvite-popup"},[_vm._v(" "+_vm._s(_vm.$t('popups.addUser.success'))+" "),_c('close-btn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }